import { render } from "./TermsOfService.vue?vue&type=template&id=01850a84"
import script from "./TermsOfService.vue?vue&type=script&lang=js"
export * from "./TermsOfService.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__